import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { getRelatorioGestaoAtendimentos } from './_requests'
import { AtendimentoGestao } from './_models'

const QueryResponseContext = createResponseContext<AtendimentoGestao>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const queryKey = [QUERIES.ATENDIMENTO_GESTAO_LIST, query, isOpen]

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(queryKey, () => getRelatorioGestaoAtendimentos(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{
        isLoading: isFetching,
        isError,
        refetch,
        response,
        query,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
